module.exports = __webpack_public_path__ + "img/section2-4.e6d5b046.png";